import { SIDE_PANEL_WIDTH } from '@/ui/layout/side-panel/constants/SidePanelWidth';
import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const sidePanelWidthState = createAtomState<number>({
  key: 'sidePanelWidthState',
  defaultValue: SIDE_PANEL_WIDTH.default,
  persistInLocalStorage: true,
});
